module.exports = "<div [ngClass]=\"{'publishing': publishing}\" #publisherDiv width=\"55px\" height=\"45px\"></div>\n"